var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBolt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_12517_487162",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 25
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_12517_487162)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.55 18.6994L15.725 12.4994H11.725L12.45 6.82435L7.82497 13.4994H11.3L10.55 18.6994ZM8.99997 15.4994H5.89997C5.49997 15.4994 5.20414 15.3202 5.01247 14.9619C4.8208 14.6035 4.84164 14.2577 5.07497 13.9244L12.55 3.17435C12.7166 2.94102 12.9333 2.77852 13.2 2.68685C13.4666 2.59519 13.7416 2.59935 14.025 2.69935C14.3083 2.79935 14.5166 2.97435 14.65 3.22435C14.7833 3.47435 14.8333 3.74102 14.8 4.02435L14 10.4994H17.875C18.3083 10.4994 18.6125 10.691 18.7875 11.0744C18.9625 11.4577 18.9083 11.816 18.625 12.1494L10.4 21.9994C10.2166 22.216 9.99164 22.3577 9.72497 22.4244C9.4583 22.491 9.19997 22.466 8.94997 22.3494C8.69997 22.2327 8.50414 22.0535 8.36247 21.8119C8.2208 21.5702 8.16664 21.3077 8.19997 21.0244L8.99997 15.4994Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBolt);
export default __webpack_public_path__ + "static/media/bolt.51947a97637cb7f0f348c359e0c81254.svg";
export { ForwardRef as ReactComponent };